var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccessContractsBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1297 507",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#edeefc;}.cls-3,.cls-4{fill:#dcdcf5;}.cls-15,.cls-4{opacity:0.29;isolation:isolate;}.cls-5{fill:#e4e5f8;}.cls-6{fill:#6e3d3d;}.cls-7{clip-path:url(#clip-path);}.cls-8{fill:#ab5654;}.cls-9{fill:#fff;}.cls-10{fill:#e9a4b3;}.cls-11,.cls-15{fill:#233862;}.cls-12{fill:#0d37c9;}.cls-13{fill:#d998a9;}.cls-14{fill:#2c3a64;}.cls-16{fill:#22d696;}.cls-17{fill:#00a7ff;}.cls-18{fill:#219367;}.cls-19{fill:#487cd3;}.cls-20{clip-path:url(#clip-path-2);}.cls-21{clip-path:url(#clip-path-3);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1103.21,56.29a.42.42,0,0,0-.43.41h0a3.79,3.79,0,0,0,2.23,3,6.77,6.77,0,0,0,7.26-.86,4.72,4.72,0,0,0,1-2.3.37.37,0,0,0-.31-.42h-.09Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M906.26,57.06a.4.4,0,0,0-.43.4h0s0,0,0,0a3.79,3.79,0,0,0,2.22,3,6.78,6.78,0,0,0,7.27-.85,4.76,4.76,0,0,0,1-2.3.38.38,0,0,0-.31-.43h-.09Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1090.23,57.06a.41.41,0,0,0-.43.4v0a3.79,3.79,0,0,0,2.23,3,6.77,6.77,0,0,0,7.26-.85,4.88,4.88,0,0,0,1-2.3.38.38,0,0,0-.32-.43h-.09Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Surface-2",
    className: "cls-2",
    x: 8.32,
    y: 67.6,
    width: 1280,
    height: 423,
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1163",
    "data-name": "Group 1163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    className: "cls-3",
    d: "M1028.67,203.94l.93-.32c1.58-.56,4.78-4.7,4.78-4.7l6,6.5-4.14,4.37c-2.36,5.53-2.4,5.63-9.54,6.71-6.19.93-5.18,4.87-9.49,5.95s-3.72-5-3.72-5c1.66-9.65,3.49-10.92,7.63-11.77-1.37-.5-2.29-1.22-2-2.13s2.38.07,6.6-.45A7.54,7.54,0,0,1,1028.67,203.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    className: "cls-3",
    d: "M1033.41,207.47a45.72,45.72,0,0,1-3.36-10s40.65-26.72,44.21-29.7,40.51-57.3,40.51-57.3l43.31,3.47s-57.75,66.66-66.93,74c-15.17,12.19-53.06,25.4-53.06,25.4A19.05,19.05,0,0,1,1033.41,207.47Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    className: "cls-3",
    d: "M1063.4,490.61h44.5c2.14-2.62,1.35-12.25,1-15.4-.07-.63-.12-1-.12-1s-15.2-12.15-17.28-2.85c-.06.3-.14.58-.22.86-2.63,8.7-14.43,12.66-21.24,13.76C1065.64,486.7,1064,489,1063.4,490.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    className: "cls-3",
    d: "M1122.3,490.61h44.5c2.13-2.62,1.35-12.25,1-15.4-.06-.63-.11-1-.11-1s-15.2-12.15-17.28-2.85a7.74,7.74,0,0,1-.23.86c-2.63,8.7-14.42,12.66-21.23,13.76C1124.54,486.7,1122.9,489,1122.3,490.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    className: "cls-3",
    d: "M1081.94,243.2s0,27.12-.08,62.42c-.12,47.15,3.16,104.75,3.6,115.68.75,19,3.8,49.38,3.8,49.38s7.21,7.22,21.64,4.18c0,0,12.87-43.37,16.54-89.26.06-.75.12-1.51.17-2.27,3.42-46.71,8.73-145.08,8.73-145.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    className: "cls-3",
    d: "M1081.94,243.2s0,26.08-.08,62.42L1123.61,417c.05-.75,3.94-33,4-33.71,3.41-46.72,8.73-145.08,8.73-145.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    className: "cls-3",
    d: "M1103.77,234s5.62,74.73,13.54,137.21c10.09,54.52,28,104.7,28,104.7s21.7,2.06,24.06-1.78c0,0,4.34-67.78-5.5-103.33-4.44-16,2.84-59.55,4.41-82.66,2-29.9-4.44-56.92-4.44-56.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    className: "cls-3",
    d: "M1105.17,93.67c16.25,5.13,44.37-8.71,44.37-8.71s-15-11.25-14.2-34.63l-12.57,10.13-8.53,6.88a101.62,101.62,0,0,0,1,11.16c.25,1.87.55,4,.94,6.23A38.87,38.87,0,0,0,1105.17,93.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    className: "cls-3",
    d: "M1114.24,67.34a101.82,101.82,0,0,0,1,11.16c9.46-1.62,20.19-16.91,20.19-16.91a30.28,30.28,0,0,0-12.62-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    className: "cls-3",
    d: "M1109.27,67s26.84,4.46,29.36-12.3,7.68-27.47-9.35-31S1108,26,1105.75,31.35,1102.35,65.36,1109.27,67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    className: "cls-3",
    d: "M1081,244.59a2.57,2.57,0,0,0,1.71.65c6.1-.08,25.38,3.35,40.44,1.8,12.69-1.22,23.93-5,36-10.39,1.6-.71,5.29-2.68,5.2-4.47,0-2-.25-4.8-.49-8.39-.85-12.46-2.34-33.88-.89-58.59.26-4.6.4-9.17.41-13.66.13-33.49-6.51-62.95-19.86-72.92-1.14-.82-8.14,2.6-14.57,5.77a26.52,26.52,0,0,1-17.5,2.12l-5.61,5c-6.84,6.35-14.32,15-17.58,28.07-2.77,11.15-4.39,31.25-5.29,52.09-.41,9.44-.73,19-.82,28V200c-.08.9-.08,1.87-.08,2.77C1081.75,225.91,1080.59,244.26,1081,244.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    className: "cls-3",
    d: "M896.76,259.62l-6.53-.93h0q-.68-.17-1.38-.27l-11.9-1.7.8-5.59a4.75,4.75,0,0,0-4-5.35l-3.1-.44-12.5-1.78-2.25-.32a4.73,4.73,0,0,0-5.35,4l-.8,5.59-20.54-2.93A14.39,14.39,0,0,0,813,262.08l-3.73,26.2A14.37,14.37,0,0,0,821.4,304.5l59.65,8.5a13.48,13.48,0,0,0,3.11.1l4.87.7a14.32,14.32,0,0,0,16.16-12.13l3.69-25.9A14.32,14.32,0,0,0,896.76,259.62Zm-43.31-11.94a1.76,1.76,0,0,1,2-1.5l2.65.37,9.84,1.4,5.36.76a1.77,1.77,0,0,1,1.5,2l-.8,5.59-21.35-3Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    className: "cls-4",
    d: "M1163.82,223.83c-.85-12.45-2.34-33.87-.89-58.59.26-4.6.4-9.17.41-13.66-5.56-13.48-10.1-23.26-10.1-23.26h-14S1129,198.48,1163.82,223.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    className: "cls-3",
    d: "M1193.48,233.07c0-.32,0-.64-.07-1-.12-1.67-3.26-5.85-3.26-5.85l7.87-4.09,3.12,5.15c4.7,3.75,4.79,3.81,3.93,11-.74,6.22,3.32,6.29,3.22,10.73s-5.81,2.26-5.81,2.26c-8.86-4.16-9.6-6.26-9.32-10.48-.84,1.19-1.78,1.89-2.58,1.37s.7-2.28,1.31-6.49A7.66,7.66,0,0,1,1193.48,233.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    className: "cls-3",
    d: "M1198.13,229.44a45.7,45.7,0,0,1-10.51.59s-15-46.28-16.91-50.5-44.5-54.26-44.5-54.26l17.73-44.38s46,76.91,50.72,87.71c7.73,17.86,10.41,57.9,10.41,57.9A19.14,19.14,0,0,1,1198.13,229.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    className: "cls-3",
    d: "M869.89,236.47c0-.32-.07-.65-.1-1-.15-1.67,2.25-6.31,2.25-6.31l-8.45-2.72-2.21,5.6c-4,4.47-4.15,5.4-4.72,11.65s.62,5.32,2.37,6a30.7,30.7,0,0,0,5.79,1.68,9.72,9.72,0,0,0,5.34-.43c2.23-.87,2.51-2,2.22-3.61a1.39,1.39,0,0,1,1.17-1.59,1.09,1.09,0,0,1,.31,0,.7.7,0,0,0,.47-.19c.61-.57-1.13-2.78-2.44-6.83A7.4,7.4,0,0,0,869.89,236.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    className: "cls-3",
    d: "M864.69,233.67a46,46,0,0,0,10.47-1.17s7.07-48.13,8.27-52.62S918.27,119,918.27,119L887.68,94.82S860.8,161.66,858,173.1c-4.65,18.9-.63,58.82-.63,58.82A19.41,19.41,0,0,0,864.69,233.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    className: "cls-3",
    d: "M853.71,490.61H834.25c-2.45-1.33-4.63-4.38-5.32-8.92-.95-6.27-8-9.69-9.5-14.82s6.27-12.34,6.27-12.34l1.3-1.68,1.35-1.74,12.92,3s.32,3.08.51,7a89.24,89.24,0,0,1,.06,9c-.38,6.83,1.91,14.2,8,15.52C854.32,486.62,854.12,489.29,853.71,490.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    className: "cls-3",
    d: "M966.63,490.61h-44.5c-2.14-2.62-1.35-12.25-1-15.4l.11-1s15.2-12.15,17.28-2.85c.07.3.15.58.23.86,2.63,8.7,14.42,12.66,21.23,13.76C964.38,486.7,966,489,966.63,490.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    className: "cls-3",
    d: "M958.15,242.23s-2.31,28.79-5,63.39c-3.68,47-8.12,104.75-8.56,115.68-.75,19-3.8,49.38-3.8,49.38s-7.21,7.22-21.64,4.18c0,0-12.87-43.37-16.54-89.26-.06-.75-.12-1.51-.17-2.27-3.42-46.71-8.73-145.08-8.73-145.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    className: "cls-3",
    d: "M958.15,242.23s-2.31,28.79-5,63.39l-50.54,80c-.06-.75-.12-1.51-.17-2.26-3.42-46.72-8.73-145.09-8.73-145.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    className: "cls-3",
    d: "M947.61,245.65S906,349.9,878.68,398.9s-35.89,62.66-35.89,62.66S827.12,455.3,825.7,451c0,0,10.46-94.58,28.77-117.64,10.35-13,22.5-52.12,23.08-65.8s3.7-40.73,3.7-40.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    className: "cls-3",
    d: "M937.26,93.67C921,98.8,892.89,85,892.89,85s15-11.25,14.2-34.63l12.57,10.13,8.53,6.88a101.84,101.84,0,0,1-1,11.16c-.25,1.87-.55,4-.94,6.23A38.7,38.7,0,0,1,937.26,93.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    className: "cls-3",
    d: "M928.19,67.34a101.84,101.84,0,0,1-1,11.16C917.76,76.88,907,61.59,907,61.59a30.11,30.11,0,0,1,12.62-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    className: "cls-3",
    d: "M933.16,67s-26.84,4.46-29.36-12.3-7.68-27.47,9.35-31,21.33,2.33,23.53,7.72S940.07,65.36,933.16,67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    className: "cls-3",
    d: "M959.94,244.63a2.62,2.62,0,0,1-1.71.65c-6.1-.08-23.9,3.31-39,1.76-12.7-1.22-23.93-5-36-10.39-1.6-.72-5.29-2.68-5.21-4.48,0-2,.25-4.8.49-8.38.86-12.46,2.35-33.88.89-58.59-.26-4.6-.4-9.17-.41-13.66-.12-33.49,6.52-62.95,19.86-72.92,1.14-.82,8.14,2.6,14.57,5.77A26.59,26.59,0,0,0,931,86.51l5.61,5c6.84,6.34,14.33,15,17.58,28.07,2.77,11.15,4.4,31.25,5.29,52.08.41,9.44.74,19,.82,28V200c.08.9.08,1.87.08,2.77C960.68,225.91,960.35,244.3,959.94,244.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    className: "cls-3",
    d: "M1013.76,203.94l-.94-.32c-1.57-.56-4.77-4.7-4.77-4.7l-6,6.5,4.14,4.37c2.36,5.53,2.4,5.63,9.54,6.71,6.19.93,5.18,4.87,9.49,5.95s3.72-5,3.72-5c-1.66-9.65-3.49-10.92-7.63-11.77,1.38-.5,2.3-1.22,2-2.13s-2.38.07-6.6-.45A7.45,7.45,0,0,0,1013.76,203.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    className: "cls-3",
    d: "M1009,207.47a45.72,45.72,0,0,0,3.36-10s-40.65-26.72-44.21-29.7-40.51-57.3-40.51-57.3L884.35,114s57.75,66.66,66.92,74c15.17,12.19,53.06,25.4,53.06,25.4A19.23,19.23,0,0,0,1009,207.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    className: "cls-3",
    d: "M960.19,193.93s-35.39-11.72-47.88-26.11c-12.67-14.6-35.56-41.33-35.56-41.33l.22-.89a116.22,116.22,0,0,1,7.45-21.2h0s3.1,18.36,12.6,31l9.51,12.67S922.16,175,960.19,193.93Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275-2",
    "data-name": "Path 275-2",
    className: "cls-3",
    d: "M937.69,18.17a15.63,15.63,0,0,0-7.33-6.44,16.33,16.33,0,0,0-9.87-.59c-3.48.82-4.17,2.18-7.76,2.85a17.86,17.86,0,0,1-7-.11,3,3,0,0,1,.33-.58,3.31,3.31,0,0,1,.56-.62,3.07,3.07,0,0,0-1.59,1.4c-.13,0-.18.08-.16.11a4,4,0,0,0-1.89-.37s.53.06.62.44l.06.11c-9.55,1.86-13.85,15.06-11.94,18.87,2.3,4.59,5,14.17,5,14.17A13.3,13.3,0,0,0,898,42.22c.27-3.44,3.1-2.69,7.07-3.24a5.35,5.35,0,0,0,1.52-.57,21.15,21.15,0,0,0,6.33-4.69c1.66-1.37,5-2.21,12.81.74a12.24,12.24,0,0,0,8.73-2.6c4-3.35,5.73-9.5,3.22-13.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275-3",
    "data-name": "Path 275-3",
    className: "cls-3",
    d: "M1101.38,24.77a13.72,13.72,0,0,1,6.46-5.67,14.37,14.37,0,0,1,8.7-.52c3.07.72,3.67,1.92,6.84,2.51a15.76,15.76,0,0,0,6.12-.1,2.58,2.58,0,0,0-.29-.51,2.89,2.89,0,0,0-.5-.55,2.7,2.7,0,0,1,1.4,1.24c.11,0,.16.07.15.1a3.41,3.41,0,0,1,1.66-.33s-.46.06-.55.39a.41.41,0,0,1,0,.09c8.42,1.65,12.21,13.27,10.52,16.63-2,4.05-4.39,12.49-4.39,12.49a11.69,11.69,0,0,1-1.12-4.57c-.23-3-2.73-2.38-6.23-2.86a4.64,4.64,0,0,1-1.34-.51,18.68,18.68,0,0,1-5.57-4.12c-1.47-1.22-4.45-2-11.29.65a10.77,10.77,0,0,1-7.7-2.29c-3.54-3-5-8.38-2.84-12.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284-3",
    "data-name": "Path 284-3",
    className: "cls-5",
    d: "M1098.47,45.91,1095.54,51a5.33,5.33,0,0,0-.68,1.52,1.78,1.78,0,0,0,.34,1.57,2.17,2.17,0,0,0,.88.54,7.81,7.81,0,0,0,4.25.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2183-5",
    "data-name": "Path 2183-5",
    className: "cls-6",
    d: "M1103.21,56.29a.42.42,0,0,0-.43.41h0a3.79,3.79,0,0,0,2.23,3,6.77,6.77,0,0,0,7.26-.86,4.72,4.72,0,0,0,1-2.3.37.37,0,0,0-.31-.42h-.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_728-5",
    "data-name": "Group 728-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    "data-name": "Group 1158"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1157",
    "data-name": "Group 1157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_727-5",
    "data-name": "Group 727-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2184-5",
    "data-name": "Path 2184-5",
    className: "cls-8",
    d: "M1101.77,58.85a12.06,12.06,0,0,1,5.73-1.13,5.41,5.41,0,0,1,2.9.84,1.81,1.81,0,0,1,.79,2.43,1.85,1.85,0,0,1-.58.66,3.94,3.94,0,0,1-1,.59,6.21,6.21,0,0,1-2.13.42,8.25,8.25,0,0,1-5.15-1.22,1.72,1.72,0,0,1-.84-1.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185-5",
    "data-name": "Path 2185-5",
    className: "cls-9",
    d: "M1104.62,55.47c-.21.1-.16.8,0,1a1.29,1.29,0,0,0,.64.25,20.77,20.77,0,0,0,5.84,0,2.08,2.08,0,0,0,.55-.12.78.78,0,0,0,.51-.68,2.31,2.31,0,0,0-.16-.69"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_739-2",
    "data-name": "Group 739-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_738-2",
    "data-name": "Group 738-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2187-2",
    "data-name": "Path 2187-2",
    className: "cls-10",
    d: "M1009.69,203.7l.93-.32c1.58-.56,4.78-4.7,4.78-4.7l6,6.5-4.13,4.37c-2.37,5.54-2.4,5.64-9.55,6.71-6.19.93-5.18,4.87-9.48,6s-3.72-5-3.72-5c1.66-9.65,3.48-10.91,7.62-11.77-1.37-.49-2.29-1.21-2-2.12s2.38.07,6.6-.46A7.67,7.67,0,0,1,1009.69,203.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188-2",
    "data-name": "Path 2188-2",
    className: "cls-11",
    d: "M1014.43,207.23a45.78,45.78,0,0,1-3.35-10s40.64-26.73,44.21-29.7,40.51-57.3,40.51-57.3l43.31,3.46s-57.76,66.66-66.94,74c-15.16,12.19-53.06,25.4-53.06,25.4A19.35,19.35,0,0,1,1014.43,207.23Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_734-2",
    "data-name": "Group 734-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2189-2",
    "data-name": "Path 2189-2",
    className: "cls-11",
    d: "M1044.42,490.37h44.5c2.14-2.61,1.35-12.25,1-15.4l-.11-1s-15.2-12.15-17.28-2.84c-.07.29-.15.57-.23.85-2.63,8.7-14.42,12.66-21.24,13.77C1046.66,486.46,1045,488.77,1044.42,490.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190-2",
    "data-name": "Path 2190-2",
    className: "cls-11",
    d: "M1103.32,490.37h44.5c2.14-2.61,1.35-12.25,1-15.4-.07-.63-.12-1-.12-1s-15.2-12.15-17.28-2.84c-.06.29-.14.57-.22.85-2.63,8.7-14.43,12.66-21.24,13.77C1105.56,486.46,1103.92,488.77,1103.32,490.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191-2",
    "data-name": "Path 2191-2",
    className: "cls-12",
    d: "M1063,243s0,27.12-.09,62.42c-.12,47.15,3.16,104.75,3.6,115.68.76,19,3.8,49.38,3.8,49.38s7.21,7.22,21.65,4.18c0,0,12.86-43.37,16.54-89.26,0-.75.11-1.51.17-2.27,3.41-46.71,8.73-145.08,8.73-145.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192-2",
    "data-name": "Path 2192-2",
    className: "cls-12",
    d: "M1063,243s0,26.09-.09,62.42l41.75,111.42c.06-.75,3.95-32.95,4-33.71,3.42-46.72,8.73-145.08,8.73-145.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193-2",
    "data-name": "Path 2193-2",
    className: "cls-12",
    d: "M1084.8,233.71s5.62,74.74,13.54,137.22c10.08,54.52,28,104.7,28,104.7s21.7,2.05,24-1.79c0,0,4.34-67.78-5.5-103.32-4.44-16,2.84-59.55,4.42-82.67,2-29.9-4.45-56.92-4.45-56.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194-2",
    "data-name": "Path 2194-2",
    className: "cls-10",
    d: "M1086.19,93.43c16.25,5.13,44.37-8.71,44.37-8.71s-15-11.24-14.2-34.63L1103.8,60.22l-8.54,6.88a102,102,0,0,0,1,11.17c.25,1.87.55,4,.94,6.23A38.84,38.84,0,0,0,1086.19,93.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195-2",
    "data-name": "Path 2195-2",
    className: "cls-13",
    d: "M1095.26,67.1a101.84,101.84,0,0,0,1,11.16c9.46-1.62,20.18-16.91,20.18-16.91a30.25,30.25,0,0,0-12.61-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196-2",
    "data-name": "Path 2196-2",
    className: "cls-10",
    d: "M1090.29,66.72s26.84,4.45,29.36-12.3,7.68-27.48-9.35-31-21.33,2.34-23.53,7.73S1083.37,65.12,1090.29,66.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197-2",
    "data-name": "Path 2197-2",
    className: "cls-11",
    d: "M1062,244.35a2.63,2.63,0,0,0,1.71.66c6.1-.09,25.38,3.34,40.44,1.8,12.69-1.22,23.93-5,36-10.39,1.6-.72,5.29-2.69,5.21-4.48-.06-2-.25-4.8-.5-8.39-.85-12.45-2.34-33.87-.89-58.59q.39-6.9.42-13.66c.12-33.49-6.52-63-19.87-72.92-1.14-.82-8.13,2.6-14.56,5.77a26.54,26.54,0,0,1-17.5,2.12l-5.62,5c-6.83,6.34-14.32,15-17.58,28.07-2.77,11.15-4.39,31.25-5.29,52.09-.4,9.44-.73,19-.81,28v.32c-.08.9-.08,1.88-.08,2.77C1062.77,225.67,1061.62,244,1062,244.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198-2",
    "data-name": "Path 2198-2",
    className: "cls-14",
    d: "M877.78,259.38l-6.53-.93h0a13.39,13.39,0,0,0-1.38-.26l-11.9-1.7.8-5.59a4.74,4.74,0,0,0-4-5.35l-3.1-.45-12.5-1.78-2.25-.32a4.74,4.74,0,0,0-5.35,4l-.8,5.59-20.54-2.93A14.38,14.38,0,0,0,794,261.85l-3.73,26.2a14.37,14.37,0,0,0,12.17,16.21l59.65,8.51a14.06,14.06,0,0,0,3.11.1l4.88.69a14.31,14.31,0,0,0,16.15-12.12l3.69-25.9A14.33,14.33,0,0,0,877.78,259.38Zm-43.31-11.94a1.78,1.78,0,0,1,2-1.5l2.66.38,9.83,1.4,5.36.76a1.76,1.76,0,0,1,1.5,2l-.8,5.59-21.34-3Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_735-2",
    "data-name": "Group 735-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2199-2",
    "data-name": "Path 2199-2",
    className: "cls-15",
    d: "M1144.84,223.59c-.85-12.45-2.34-33.87-.89-58.59.26-4.6.4-9.16.42-13.65-5.56-13.49-10.1-23.27-10.1-23.27h-14S1110,198.25,1144.84,223.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2200-2",
    "data-name": "Path 2200-2",
    className: "cls-10",
    d: "M1174.5,232.84q0-.48-.06-1c-.13-1.67-3.27-5.85-3.27-5.85l7.87-4.08,3.12,5.15c4.7,3.74,4.79,3.81,3.93,11-.74,6.21,3.33,6.29,3.23,10.72s-5.82,2.26-5.82,2.26c-8.86-4.16-9.6-6.25-9.32-10.48-.84,1.2-1.78,1.89-2.58,1.37s.7-2.27,1.31-6.48A7.57,7.57,0,0,1,1174.5,232.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201-2",
    "data-name": "Path 2201-2",
    className: "cls-11",
    d: "M1179.16,229.21a45.75,45.75,0,0,1-10.52.58s-15-46.28-16.91-50.5-44.5-54.26-44.5-54.26L1125,80.65s46,76.91,50.71,87.72c7.73,17.85,10.41,57.9,10.41,57.9A19.44,19.44,0,0,1,1179.16,229.21Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_737-2",
    "data-name": "Group 737-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2202-2",
    "data-name": "Path 2202-2",
    className: "cls-10",
    d: "M850.92,236.23c0-.32-.08-.64-.1-1-.16-1.66,2.24-6.31,2.24-6.31l-8.44-2.72-2.22,5.6c-4,4.48-4.15,5.4-4.72,11.66s.62,5.32,2.38,6a30.42,30.42,0,0,0,5.78,1.69,9.76,9.76,0,0,0,5.35-.44c2.22-.87,2.51-2,2.21-3.61a1.39,1.39,0,0,1,1.18-1.59,1.51,1.51,0,0,1,.3,0,.67.67,0,0,0,.47-.18c.62-.57-1.13-2.79-2.43-6.84A7.65,7.65,0,0,0,850.92,236.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203-2",
    "data-name": "Path 2203-2",
    className: "cls-16",
    d: "M845.72,233.43a46,46,0,0,0,10.46-1.17s7.07-48.13,8.27-52.62,34.84-60.91,34.84-60.91L868.7,94.58S841.82,161.43,839,172.86c-4.64,18.9-.62,58.82-.62,58.82A19.13,19.13,0,0,0,845.72,233.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_736-2",
    "data-name": "Group 736-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2204-2",
    "data-name": "Path 2204-2",
    className: "cls-11",
    d: "M834.73,490.37H815.27c-2.45-1.33-4.63-4.38-5.32-8.92-1-6.27-8-9.68-9.5-14.81s6.27-12.34,6.27-12.34l1.3-1.68,1.35-1.74,12.92,3s.32,3.07.51,7a89.24,89.24,0,0,1,.06,9c-.38,6.83,1.91,14.2,8,15.53C835.34,486.38,835.14,489.05,834.73,490.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205-2",
    "data-name": "Path 2205-2",
    className: "cls-11",
    d: "M947.65,490.37h-44.5c-2.14-2.61-1.35-12.25-1-15.4l.11-1s15.2-12.15,17.29-2.84c.06.29.14.57.22.85,2.63,8.7,14.43,12.66,21.24,13.77C945.41,486.46,947.05,488.77,947.65,490.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206-2",
    "data-name": "Path 2206-2",
    className: "cls-17",
    d: "M939.17,242s-2.31,28.79-5,63.39c-3.68,47-8.11,104.75-8.55,115.68-.76,19-3.8,49.38-3.8,49.38s-7.21,7.22-21.65,4.18c0,0-12.86-43.37-16.54-89.26-.06-.75-.11-1.51-.17-2.27C880,336.38,874.71,238,874.71,238Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207-2",
    "data-name": "Path 2207-2",
    className: "cls-17",
    d: "M939.17,242s-2.31,28.79-5,63.39l-50.54,80c-.06-.75-.11-1.51-.17-2.27C880,336.38,874.71,238,874.71,238Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208-2",
    "data-name": "Path 2208-2",
    className: "cls-17",
    d: "M928.64,245.41S887.05,349.67,859.7,398.66s-35.89,62.67-35.89,62.67-15.66-6.27-17.08-10.54c0,0,10.45-94.59,28.77-117.64,10.34-13,22.5-52.13,23.07-65.8s3.7-40.74,3.7-40.74Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209-2",
    "data-name": "Path 2209-2",
    className: "cls-10",
    d: "M918.28,93.43c-16.25,5.13-44.37-8.71-44.37-8.71s15-11.24,14.2-34.63l12.57,10.13,8.54,6.88a104.36,104.36,0,0,1-1,11.16q-.37,2.8-.94,6.23A39.14,39.14,0,0,1,918.28,93.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210-2",
    "data-name": "Path 2210-2",
    className: "cls-13",
    d: "M909.21,67.1a101.82,101.82,0,0,1-1,11.16c-9.46-1.62-20.19-16.91-20.19-16.91a30.28,30.28,0,0,1,12.62-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211-2",
    "data-name": "Path 2211-2",
    className: "cls-10",
    d: "M914.18,66.72s-26.84,4.45-29.36-12.3-7.68-27.48,9.35-31,21.33,2.34,23.53,7.73S921.1,65.12,914.18,66.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212-2",
    "data-name": "Path 2212-2",
    className: "cls-16",
    d: "M941,244.39a2.59,2.59,0,0,1-1.71.65c-6.1-.08-23.9,3.31-39,1.76-12.69-1.22-23.93-5-36-10.39-1.6-.71-5.29-2.68-5.21-4.47.06-2,.25-4.8.5-8.39.85-12.45,2.34-33.88.89-58.59-.26-4.6-.4-9.17-.42-13.66-.12-33.49,6.52-63,19.87-72.92,1.14-.82,8.14,2.6,14.57,5.77A26.58,26.58,0,0,0,912,86.27l5.61,5c6.83,6.35,14.32,15,17.58,28.08,2.77,11.15,4.4,31.25,5.29,52.08.4,9.44.73,19,.81,28v.33c.08.9.08,1.87.08,2.77C941.7,225.67,941.37,244.07,941,244.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213-2",
    "data-name": "Path 2213-2",
    className: "cls-10",
    d: "M994.78,203.7c-.31-.1-.62-.2-.93-.32-1.58-.56-4.78-4.7-4.78-4.7l-6,6.5,4.13,4.37c2.36,5.54,2.4,5.64,9.54,6.71,6.19.93,5.19,4.87,9.49,6s3.72-5,3.72-5c-1.66-9.65-3.48-10.91-7.62-11.77,1.37-.49,2.29-1.21,2-2.12s-2.38.07-6.6-.46A7.67,7.67,0,0,0,994.78,203.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214-2",
    "data-name": "Path 2214-2",
    className: "cls-16",
    d: "M990.05,207.23a46.32,46.32,0,0,0,3.35-10s-40.64-26.73-44.21-29.7-40.51-57.3-40.51-57.3l-43.31,3.46s57.75,66.66,66.93,74c15.16,12.19,53.06,25.4,53.06,25.4A19.38,19.38,0,0,0,990.05,207.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215-2",
    "data-name": "Path 2215-2",
    className: "cls-18",
    d: "M941.21,193.69S905.83,182,893.34,167.58c-12.68-14.6-35.57-41.33-35.57-41.33l.22-.89a115.15,115.15,0,0,1,7.46-21.19h0s3.09,18.36,12.6,31l9.5,12.68S903.19,174.74,941.21,193.69Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275-2-2",
    "data-name": "Path 275-2-2",
    className: "cls-19",
    d: "M924.72,17.94a15.52,15.52,0,0,0-7.33-6.44,16.18,16.18,0,0,0-9.87-.59c-3.49.82-4.18,2.17-7.77,2.84a17.87,17.87,0,0,1-7-.11,3.46,3.46,0,0,1,.89-1.2,3.07,3.07,0,0,0-1.59,1.4c-.12.05-.18.09-.16.11a4,4,0,0,0-1.89-.37s.53.06.63.44a.24.24,0,0,0,.06.11c-9.56,1.86-13.86,15.06-12,18.87,2.3,4.6,5,14.17,5,14.17A13.3,13.3,0,0,0,885.05,42c.26-3.44,3.1-2.7,7.07-3.25a5.41,5.41,0,0,0,1.51-.57A21,21,0,0,0,900,33.48c1.66-1.37,5-2.22,12.81.74a12.21,12.21,0,0,0,8.73-2.6c4-3.35,5.74-9.5,3.23-13.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275-3-2",
    "data-name": "Path 275-3-2",
    className: "cls-19",
    d: "M1079.71,21.05a15.62,15.62,0,0,1,7.34-6.43,16.17,16.17,0,0,1,9.87-.59c3.48.81,4.17,2.17,7.76,2.84a17.86,17.86,0,0,0,7-.11,3.46,3.46,0,0,0-.89-1.2,3.07,3.07,0,0,1,1.59,1.4c.12.05.18.09.16.11a4,4,0,0,1,1.89-.37s-.53.06-.62.44a.41.41,0,0,1-.07.11c9.56,1.86,13.86,15.06,12,18.87-2.3,4.6-5,14.17-5,14.17a13.31,13.31,0,0,1-1.28-5.18c-.26-3.44-3.1-2.7-7.07-3.25a5.14,5.14,0,0,1-1.51-.58,21.06,21.06,0,0,1-6.33-4.68c-1.66-1.37-5-2.22-12.81.74a12.25,12.25,0,0,1-8.74-2.6c-4-3.35-5.73-9.5-3.22-13.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284-2",
    "data-name": "Path 284-2",
    className: "cls-10",
    d: "M919.05,43.17l2.93,5.1a5,5,0,0,1,.68,1.52,1.81,1.81,0,0,1-.33,1.57,2.27,2.27,0,0,1-.89.54,7.81,7.81,0,0,1-4.25.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284-3-2",
    "data-name": "Path 284-3-2",
    className: "cls-10",
    d: "M1085.49,45.67l-2.93,5.09a5.3,5.3,0,0,0-.67,1.52,1.8,1.8,0,0,0,.33,1.58,2.36,2.36,0,0,0,.88.54,7.93,7.93,0,0,0,4.26.43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2183-4",
    "data-name": "Path 2183-4",
    className: "cls-6",
    d: "M906.26,57.06a.4.4,0,0,0-.43.4h0s0,0,0,0a3.79,3.79,0,0,0,2.22,3,6.78,6.78,0,0,0,7.27-.85,4.76,4.76,0,0,0,1-2.3.38.38,0,0,0-.31-.43h-.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_728-4",
    "data-name": "Group 728-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1160",
    "data-name": "Group 1160"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1159",
    "data-name": "Group 1159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_727-4",
    "data-name": "Group 727-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2184-4",
    "data-name": "Path 2184-4",
    className: "cls-8",
    d: "M904.82,59.61a12.05,12.05,0,0,1,5.73-1.12,5.34,5.34,0,0,1,2.9.83,1.82,1.82,0,0,1,.79,2.44,1.94,1.94,0,0,1-.58.66,4.46,4.46,0,0,1-1,.58,6,6,0,0,1-2.14.42,8.22,8.22,0,0,1-5.14-1.21,1.74,1.74,0,0,1-.84-1.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185-4",
    "data-name": "Path 2185-4",
    className: "cls-9",
    d: "M907.66,56.23c-.21.11-.15.81,0,1a1.27,1.27,0,0,0,.64.25,20.48,20.48,0,0,0,5.85,0,1.75,1.75,0,0,0,.55-.12.78.78,0,0,0,.51-.68A2.41,2.41,0,0,0,915,56"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_741-2",
    "data-name": "Group 741-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2183-5-2",
    "data-name": "Path 2183-5-2",
    className: "cls-6",
    d: "M1090.23,57.06a.41.41,0,0,0-.43.4v0a3.79,3.79,0,0,0,2.23,3,6.77,6.77,0,0,0,7.26-.85,4.88,4.88,0,0,0,1-2.3.38.38,0,0,0-.32-.43h-.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_728-5-2",
    "data-name": "Group 728-5-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    "data-name": "Group 1162"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_727-5-2",
    "data-name": "Group 727-5-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2184-5-2",
    "data-name": "Path 2184-5-2",
    className: "cls-8",
    d: "M1088.79,59.61a12.05,12.05,0,0,1,5.73-1.12,5.29,5.29,0,0,1,2.9.83,1.81,1.81,0,0,1,.79,2.44,1.75,1.75,0,0,1-.58.66,4.23,4.23,0,0,1-1,.58,6,6,0,0,1-2.13.42,8.28,8.28,0,0,1-5.14-1.21,1.72,1.72,0,0,1-.85-1.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185-5-2",
    "data-name": "Path 2185-5-2",
    className: "cls-9",
    d: "M1091.64,56.23c-.21.11-.16.81,0,1a1.24,1.24,0,0,0,.64.25,20.41,20.41,0,0,0,5.84,0,1.69,1.69,0,0,0,.55-.12.78.78,0,0,0,.51-.68A2.39,2.39,0,0,0,1099,56"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessContractsBanner);
export default __webpack_public_path__ + "static/media/access-contracts-banner.d9bcbe48b4e22b1afd9bcbc243b740ed.svg";
export { ForwardRef as ReactComponent };